import express, { Router } from 'express';
import type { RouterOptions } from './types';
import { resolveLogDir } from './utils';
import {
  createGetTraceEntriesHandler,
  createGetRecentTracesHandler,
  createGetLogFileHandler,
  createGetServerLogsHandler,
  createGetTriggerListHandler,
  createGetTriggerDetailHandler,
  createGetCapabilityTraceListHandler,
} from './controller';
import { createHealthCheckHandler } from './health.controller';
import { createSSEHandler } from './sse';
import { createApiListHandler } from './api-list-handler';
/**
 * Create dev log router with all routes registered
 */
export function createDevLogRouter(options: RouterOptions = {}): Router {
  const logDir = resolveLogDir(options.logDir);
  const router = express.Router();

  // GET /app/trace/:traceId - Get log entries by trace ID
  router.get('/app/trace/:traceId', createGetTraceEntriesHandler(logDir));

  // GET /trace/recent - Get recent trace calls with pagination
  router.get('/trace/recent', createGetRecentTracesHandler(logDir));

  // GET /files/:fileName - Get paginated log file content
  router.get('/files/:fileName', createGetLogFileHandler(logDir));

  // GET /server-logs - Get server logs in ServerLog format (compatible with frontend)
  router.get('/server-logs', createGetServerLogsHandler(logDir));

  // GET /server-logs/stream - SSE endpoint for real-time server logs
  router.get('/server-logs/stream', createSSEHandler(logDir));
  
  // GET /trace/trigger/list - get all automation trigger list in trace.log
  router.get('/trace/trigger/list', createGetTriggerListHandler(logDir));

  // GET /trace/trigger/:instanceID - get automation trigger detail by instanceID in server.log
  router.get('/trace/trigger/:instanceID', createGetTriggerDetailHandler(logDir));

  // GET /trace/capability/list - get capability trace list by capability_id in server.log
  router.get('/trace/capability/list', createGetCapabilityTraceListHandler(logDir));

  router.get('/health', createHealthCheckHandler());

  // GET /api-list - 获取所有 API 路由（从 api-routes 迁移过来）
  router.get('/api-list', createApiListHandler());

  return router;
}
